<template>
  <div>
    <div id="notes-form-dataset">
      <h3 class="grey--text text--darken-3 mt-10 d-flex">
        <span>Notes <small><i>(Click a record to update)</i></small><span class="red--text">*</span></span>
        <base-popup-btn
          v-if="consultation.status != 'submitted'"
          class="ml-auto"
          @click="addNote"
        >
          Add Note
        </base-popup-btn>
      </h3>
      <v-row>
        <v-col cols="12">

          <div v-if="notes">
            <base-table :headers="headers" :items="notes">
              <template v-slot:item="{ item, index }">
                <tr :id="'note-instance-' + index" @click="updateNote(index, item.title)">
                  <td>{{ item.title }}</td>
                  <td>{{ item.note }}</td>
                </tr>
              </template>
            </base-table>
          </div>

        </v-col>
      </v-row>

      <p>&nbsp;</p>
      <hr />
      <p>&nbsp;</p>

    </div>

    <!-- ############################################################################################################################################################################### -->


    <h3 class="grey--text text--darken-3 mt-10 d-flex">
      Requests
    </h3>

    <v-row>
      <!-- PDF -->
      <v-col cols="5" class="pb-0">
        <v-select class="primary-label" v-model="destination_email" label="Patient Email Address" placeholder=" " :items="patient_emails"></v-select>
      </v-col>
    </v-row>

    <v-row>
      <!-- Care Plan -->
      <v-col cols="12" class="d-flex pb-0">
        <v-checkbox dense v-model="plan">
          <template v-slot:label>
            <span :class="[!plan ? 'grey--text text--lighten-1' : '']">
              Care Plan
            </span>
          </template>
        </v-checkbox>
      </v-col>

      <!-- Prescription -->
      <v-col cols="12" class="pt-0">
        <v-row>
          <v-col>
            <v-checkbox dense v-model="prescription" @change="medex = $event ? false : false" hide-details>
              <template v-slot:label>
                <span :class="[!prescription ? 'grey--text text--lighten-1' : 'primary--text']">
                  Prescription
                </span>
              </template>
            </v-checkbox>
          </v-col>
        </v-row>
        
        <!-- send to medexpress -->
        <v-row v-show="prescription">
          <v-col class="pt-0">
            <v-checkbox :disabled="!prescription" dense hide-details v-model="medex" class="px-5">
              <template v-slot:label>
                <span :class="[!medex ? 'grey--text text--lighten-1' : '']">
                  Send to MedExpress
                </span>
              </template>
            </v-checkbox>
          </v-col>
        </v-row>
      </v-col>

      <!-- Med Cert Rejected -->
      <v-col cols="12">
        <v-row>
          <v-col class="pt-0">
            <v-checkbox dense v-model="certificate_rejected" @change="certificate = certificate ? false : false" hide-details class="py-0">
              <template v-slot:label>
                <span :class="[!certificate_rejected ? 'grey--text text--lighten-1' : 'primary--text']">
                  Medical Certificate Rejected
                </span>
              </template>
            </v-checkbox>
          </v-col>
        </v-row>
        <v-row v-show="certificate_rejected" class="px-8">
          <v-col cols="5">
            <v-textarea 
              v-model="rejection_reason" 
              label="Reason for Rejection" 
              rows="3" placeholder=""
              v-on:focus="() => {this.$vtt.startSpeechListener((text) => { this.rejection_reason = `${this.rejection_reason || ''} ${text}`;}, 'rejection_reason')}"
              v-on:click="() => {this.$vtt.setModel('rejection_reason');}"
              @input="setHint(rejection_reason, (replacement) => { rejection_reason = replacement })"
              @keydown.tab="(e) => {
                if (!getReplacement(rejection_reason)) { return true; } else { e.preventDefault(); rejection_reason = getReplacement(rejection_reason); clearReplacement(); }
              }"
            >
              <template v-slot:label>
                <span class="primary--text">Reason for Rejection</span>
              </template>
            </v-textarea>
          </v-col>
        </v-row>
      </v-col>


      <!-- ***************************************************** MEDICAL CERTIFICATE ***************************************************** -->


      <v-col cols="12">
        <div id="case-medical-certificate-form">
          
          <!-- ##################################################### MEDICAL CERTIFICATE DISPLAY ##################################################### -->

            <v-row>
              <v-col cols="5" class="pt-0">
                <v-checkbox dense v-model="certificate" @change="certificate_rejected = certificate_rejected ? false : false" hide-details class="py-0">
                  <template v-slot:label>
                    <span :class="[!certificate ? 'grey--text text--lighten-1' : 'primary--text']">
                      Medical Certificate
                      <!-- <br />
                      <span style="color: red;">Medical Certificate Note: </span> 
                      <i v-if="medicalCertificateQuantity">Sent: {{ medicalCertificateQuantity.Sent }} | Limit: {{ medicalCertificateQuantity.Limit }}</i>
                      <i v-if="!medicalCertificateQuantity">Sent: 0 | Limit: 0</i> -->
                    </span>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>

            <!-- <v-row v-show="!medicalCertificateQuantity">
              <v-col cols="5" class="pt-0">
                <v-checkbox dense v-model="certificate" @change="certificate_rejected = certificate_rejected ? false : false" hide-details class="py-0">
                  <template v-slot:label>
                    <span :class="[!certificate ? 'grey--text text--lighten-1' : 'primary--text']">
                      <h5>
                        <span style="color: red;">Medical Certificate Note:</span> 
                        <i v-if="!medicalCertificateQuantity">Sent: 0 | Limit: 0</i>
                        Medical Certificate
                      </h5>
                    </span>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row> -->

          <!-- ##################################################### MEDICAL CERTIFICATE DISPLAY ##################################################### -->

          <div v-if="medicalCertificateQuantity">
            <v-row v-show="medicalCertificateQuantity.Limit && (medicalCertificateQuantity.Limit.toLowerCase() != 'unlimited' && medicalCertificateQuantity.Limit < medicalCertificateQuantity.Sent)">
              <v-col cols="12">
                <h5 style="color: red;">This patient has reached the limit for Medical Certificate</h5>
              </v-col>
            </v-row>
          </div>

          <v-row v-show="certificate" class="px-8">
            <v-col cols="5">
              <v-select
                v-model="rest_days"
                :items="['For ER','0','1','2','3']"
                @change="certificate_remark = $event=='For ER' ? 'Proceed to the Emergency Room now.' : ''"
                placeholder=" ">
                <template v-slot:label>
                  <span class="primary--text">Number of Days</span>
                </template>
              </v-select>
            </v-col>
          </v-row>
          
          <v-row v-show="certificate" class="px-8">
            <v-col cols="5" class="py-0">
              <v-textarea
                :readonly="rest_days == 'For ER'"
                v-model="certificate_remark"
                rows="3"
                placeholder=" "
                v-on:focus="() => {this.$vtt.startSpeechListener((text) => { this.certificate_remark = `${this.certificate_remark || ''} ${text}`;}, 'certificate_remark')}"
                v-on:click="() => {this.$vtt.setModel('certificate_remark');}"
                @input="setHint(certificate_remark, (replacement) => { certificate_remark = replacement })"
                @keydown.tab="(e) => {
                  if (!getReplacement(certificate_remark)) { return true; } else { e.preventDefault(); certificate_remark = getReplacement(certificate_remark); clearReplacement(); }
                }"
              >
                <template v-slot:label>
                  <span class="primary--text">Remarks</span>
                </template>
              </v-textarea>
            </v-col>
          </v-row>

        </div>
      </v-col>

      <!-- ***************************************************** MEDICAL CERTIFICATE ***************************************************** -->



      <!-- Laboratory checkbox -->
      <v-col cols="12" class="py-0">
        <v-row dense align="center">
          <v-col class="d-flex align-center">
            <v-checkbox dense v-model="laboratory">
            </v-checkbox>
            <span :class="['clickable', 'grey--text text--lighten-1', { 'primary--text': laboratory }]" @click="laboratory = !laboratory">
              Laboratory
            </span>
          </v-col>
        </v-row>
      </v-col>

      <!-- Laboratory test checkboxes -->
      <v-col cols="12" class="mt-0 py-0">
        <v-slide-y-transition>
          <v-row v-show="laboratory" class="mx-5" dense>
            
            <v-col v-for="labtest in labtests" :key="labtest.name" cols="4" class="pa-0">
              <lab-item v-model="labtest.val" :label="labtest.name" @check="addTest(labtest.name, labtest.val)"></lab-item>
            </v-col>

            <v-col v-show="isOthers" cols="12" class="pa-0">
              <v-row>
                <!-- others -->
                <v-col cols="10" class="mb-5">
                  <v-textarea :rules="[v => (v || '' ).length <= 100 || 'Description must be 100 characters or less']" placeholder=" " rows="3" hide-details v-model="other_tests"
                      v-on:focus="() => {this.$vtt.startSpeechListener((text) => { this.other_tests = `${this.other_tests || ''} ${text}`;}, 'other_tests')}"
                      v-on:click="() => {this.$vtt.setModel('other_tests');}"
                      @input="setHint(other_tests, (replacement) => { other_tests = replacement })"
                      @keydown.tab="(e) => {
                        if (!getReplacement(other_tests)) { return true; } else { e.preventDefault(); other_tests = getReplacement(other_tests); clearReplacement(); }
                      }"
                    >
                    <template v-slot:label>
                      <span :class="['clickable', 'grey--text',{ 'primary--text': others }]" style="font-size: 21px;" @click="others = true">
                        Please specify other tests to be done:
                      </span>
                    </template>
                  </v-textarea>
                  <span style="color: red;" v-if="other_tests && other_tests.length > 100">Reached maximum description limit</span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-slide-y-transition>
      </v-col>

      <!-- Image Request -->
      <v-col cols="12" class="d-flex pb-0">
        <v-checkbox dense v-model="image">
          <template v-slot:label>
            <span :class="[!image ? 'grey--text text--lighten-1' : '']">
              Image Request
            </span>
          </template>
        </v-checkbox>
      </v-col>
    </v-row>

    <!-- NOTE DIALOG -->
    <v-dialog v-model="noteDialog" content-class="elevation-0" width="70vw" max-width="600px">
      <v-card>
        <v-card-title class="primary--text">Notes</v-card-title>
        
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <!-- Note title -->
            <v-text-field 
              v-model="title" 
              placeholder=" " 
              :rules="rules.required"
              v-on:focus="() => {this.$vtt.startSpeechListener((text) => { this.title = `${this.title || ''} ${text}`;}, 'notes_title')}"
              v-on:click="() => {this.$vtt.setModel('notes_title');}"  
              @input="setHint(title, (replacement) => { title = replacement })"
              @keydown.tab="(e) => {
                if (!getReplacement(title)) { return true; } else { e.preventDefault(); title = getReplacement(title); clearReplacement(); }
              }"
            >
              <template v-slot:label>
                <h3>Title <span class="red--text">*</span></h3>
              </template>
            </v-text-field>

            <!-- Note text -->
            <v-textarea 
              v-model="note" 
              placeholder=" " 
              rows="3"
              v-on:focus="() => {this.$vtt.startSpeechListener((text) => { this.note = `${this.note || ''} ${text}`;}, 'notes_note')}"
              v-on:click="() => {this.$vtt.setModel('notes_note');}"
              @input="setHint(note, (replacement) => { note = replacement })"
              @keydown.tab="(e) => {
                if (!getReplacement(note)) { return true; } else { e.preventDefault(); note = getReplacement(note); clearReplacement(); }
              }"
            >
              <template v-slot:label>
                <h3>Note</h3>
              </template>
            </v-textarea>
            <VTTButton :mode="'checkbox'" />
          </v-form>
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="d-flex justify-center">
          <!-- Add/ Update Button -->
          <v-btn rounded small color="primary" class="px-6 mx-2" @click="saveNote">
            {{ noteUpdate?'Update':'Add' }}
          </v-btn>

          <!-- Remove Button -->
          <v-btn rounded small color="error" class="px-6 mx-2" v-if="noteUpdate" @click="removeNote">Remove</v-btn>

          <!-- Cancel Button -->
          <v-btn rounded small color="primary lighten-5" class="px-6 mx-2 primary--text" @click="cancelNote">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

  import VTTButton from '../../../../../components/custom/VTTButton.vue';
  import textreplacementmixin from '../../../../../mixins/textreplacementmixin';

  export default {
    name: 'FormNotes',

    mixins: [textreplacementmixin],

    components: {
      LabItem: () => import('./NotesLabItem.vue'),
      VTTButton
    },

    data: ()=>({
      isOthers: false,
      valid: false,
      rules: {
       required: [value => !!value || "This field is required."]
      },
      others: undefined,
      noteDialog: false,
      noteUpdate: false,

      headers: [
        { text: 'Title', value: 'title', class:'primary--text' },
        { text: 'Note', value: 'note', class:'primary--text' },
      ],

      labtests: [
        { name:'CBC', val: false },
        { name:'RBS', val: false },
        { name:'Urinalysis', val: false },
        { name:'Actual Platelet Count', val: false },
        { name:'Typhidot', val: false },
        { name:'Dengue Test NS1 Antigen (Qual)', val: false },
        { name:'Fecalysis', val: false },
        { name:'HBsAG', val: false },
        { name:'SGOT', val: false },
        { name:'SGPT', val: false },
        { name:'BUN', val: false },
        { name:'Creatinine', val: false },
        { name:'BUA', val: false },
        { name:'HBA1c', val: false },
        { name:'Sodium', val: false },
        { name:'Potassium', val: false },
        { name:'FBS', val: false },
        { name:'Lipid Profile', val: false },
        { name:'Cholesterol', val: false },
        { name:'Triglyceride', val: false },
        { name:'HDL', val: false },
        { name:'LDL', val: false },
        { name:'Upper Abdomen UTS', val: false },
        { name:'Pelvis/Pelvic UTS', val: false },
        { name:'KUB UTS', val: false },
        { name:'HBT (Gallbladder, Liver) UTS', val: false },
        { name:'Transvaginal UTS', val: false },
        { name:'Chest XRAY (AP-L)', val: false },
        { name:'Chest XRAY (PA)', val: false },
        { name:'ECG', val: false },
        { name:"PAP's Smear", val: false },
        { name:'FT4', val: false },
        { name:'TSH', val: false },
        { name:'Total Protein', val: false },
        { name:'Ionized Calcium', val: false },
        { name:'Thyroid UTS', val: false },
        { name:'Urine Culture & Sensitivity', val: false },
        { name:'Leptospira lgG lgM', val: false },
        { name:'Alk Phos', val: false },
        { name:'COVID-19 RT-PCR (NPS & OPS)', val: false },
        { name:'Others', val: false },
      ]
      
    }),

    watch: {
      requestIndex() {
        this.labtests.forEach(element => {
          element.val = false
        });
      },

      notes: function (val) {
        this.notes = val;
      },

      certificate_rejected(val) {
        if (!val) {
          this.rejection_reason = ''
        }
      },

      tests(labtests_instance) {
        if(labtests_instance) {
          let that = this
          labtests_instance.forEach(element => {
            // if preselected tests exists (from DB) and was found in the list of available labtests array, then set that labtest array value to "TRUE"
            that.isOthers = this.tests.includes("Others");
            console.log("[labtest instance]", element);
          });
        } else {
          console.log("labtest instance doesnt exist");
        }
      }
    },

    computed: {
      consultation() { return this.$store.getters['consultation/activeInfo'] },
      medicalCertificateQuantity: {
        get() { return this.$store.getters['cases/medicalCertificateQuantity'] },
        set() { this.$store.getters['cases/updateMedicalCertificateQuantity'] }
      },

      patient_emails() {
        var emails = []
        emails = this.$store.getters['patient/email_options'];
        return emails.filter(email => email != 'N/A');
      },

      requestIndex() { return this.$store.getters['request/tests_index'] },
      activeIndex() { return this.$store.getters['consultation/activeIndex'] },
      tests() { return this.$store.getters['request/tests'] },
      
      notes: {
        get() { return this.$store.getters['cases/notes'] },
        set() { this.$store.getters['cases/updatenotes'] }
      },
      
      title: {
        get() { return this.$store.getters['cases/title'] },
        set(val) { this.$store.commit('cases/updateTitle', val) }
      },
      
      note: {
        get() { return this.$store.getters['cases/note'] },
        set(val) { this.$store.commit('cases/updateNote', val) }
      },

      plan: {
        get() { return this.$store.getters['request/plan'] },
        set() { this.$store.commit('request/setPlan') }
      },
      prescription: {
        get() { return this.$store.getters['request/prescription'] },
        set() { this.$store.commit('request/setPrescription') }
      },
      medex: {
        get() { return this.$store.getters['request/medex'] },
        set(val) { this.$store.commit('request/setMedex', val) }
      },
      certificate: {
        get() { return this.$store.getters['request/certificate'] },
        set(val) { this.$store.commit('request/setCertificate', val) }
      },
      certificate_rejected: {
        get() { return this.$store.getters['request/certificate_rejected'] },
        set(val) { this.$store.commit('request/setCertificateRejected', val) }
      },
      laboratory: {
        get() { return this.$store.getters['request/laboratory'] },
        set(val) { this.$store.commit('request/setLaboratory', val) }
      },
      image: {
        get() { return this.$store.getters['request/image'] },
        set() { this.$store.commit('request/setImage') }
      },
      rest_days: {
        get() { return this.$store.getters['request/rest_days'] },
        set(val) { this.$store.commit('request/setRestDays', val) }
      },
      
      other_tests: {
        get() { return this.$store.getters['request/other_tests'] },
        set(val) { this.$store.commit('request/setTestOthers', val) }
      },

      destination_email: {
        get() { return this.$store.getters['request/destination_email'] },
        set(val) { this.$store.commit('request/setDestinationEmail', val) }
      },


      certificate_remark: {
        get() { return this.$store.getters['request/certificate_remark'] },
        set(val) { this.$store.commit('request/setCertificateRemark', val) }
      },
      rejection_reason: {
        get() { return this.$store.getters['request/rejection_reason'] },
        set(val) { this.$store.commit('request/setRejectionReason', val) }
      }
    },

    mounted() {
      console.log("mounted");
      console.log(this.tests);
      if (this.tests.length >= 1) {
        setTimeout(() => {
          this.loadTests()
        }, 3000)
      }
    },

    methods: {
      
      async loadTests() {
        var that = this
        
        console.log("labtests here");
        console.log("[labtests]", this.labtests);
        console.log("[that.tests]", that.tests);

        await this.labtests.forEach(element => {
          // if preselected tests exists (from DB) and was found in the list of available labtests array, then set that labtest array value to "TRUE"
          console.log("[labtest loop]", element.name);
          element.val = that.tests.includes(element.name)
        });
      },
      
      addNote() {
        this.$store.commit('cases/clearNote');
        this.noteDialog = true;
        this.noteUpdate = false;
      },
      
      updateNote(index, title) {
        this.noteDialog = true;
        this.noteUpdate = true;

        let selIndex = this.notes.findIndex( x => x.title === title );

        console.log('NOTESSSS: ', index)

        this.$store.commit('cases/setActiveNote', selIndex);
      },
      
      cancelNote() {
        this.$refs.form.resetValidation();
        this.noteDialog = false;
        this.noteUpdate = false;
      },
      
      saveNote() {
        this.$refs.form.validate();

        if (this.valid) {
          if (this.noteUpdate) {
            let index = this.$store.getters['cases/activeNote'];
            this.$store.commit('cases/editNote', index);
            console.log("here");
          } else {
            this.$store.commit('cases/addNote');
          }

          console.log("clear_note");
          this.$store.commit('cases/clearNote');
          this.noteDialog = false;
        }
      },

      removeNote() {
        this.$store.commit('cases/removeNote');
        this.noteDialog = false;
      },

      addTest(name, value) {
        this.$store.commit('request/updateTest', {name: name, value: value})
      }
    }
  }
</script>

<style lang="scss" scoped>
.dotted-hr {
  border-top: 1px dashed grey;
}
</style>